// eslint-disable-line
import './DialogModal.css'

const CommonModal = ({ children, closeModal, name }) => (
  <div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">{name}</h5>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">{children[0]}</div>
      <div className="modal-footer">{children[1]}</div>
    </div>
  </div>
)

CommonModal.defaultProps = {
  children: null,
  closeModal: null,
  name: 'Modal',
}

export default CommonModal
